/* eslint-disable no-async-promise-executor */
import ajax from "@/plugins/ajax";
import { t } from "@/languages";
import { Message } from "element-ui";
const state = {
  temuPublishSite: {}, // temu站点
  publishSiteIdMap: {}, // temu站点id映射
  siteCustomTimeMap: [
    // 站点发货时效
    {
      label: "美国站",
      key: "shipmentLimitUsDay",
      defaultVal: 9,
      value: 100,
    },
    {
      label: "墨西哥站",
      key: "shipmentLimitMXDay",
      defaultVal: 13,
      value: 110,
    },
    {
      label: "智利站",
      key: "shipmentLimitCLDay",
      defaultVal: 12,
      value: 125,
    },
    {
      label: "秘鲁站",
      key: "shipmentLimitPEDay",
      defaultVal: 15,
      value: 163,
    },
    {
      label: "哥伦比亚站",
      key: "shipmentLimitCODay",
      defaultVal: 16,
      value: 164,
    },
    {
      label: "厄瓜多尔站",
      key: "shipmentLimitECDay",
      defaultVal: 20,
      value: 178,
    },
    {
      label: "其它站",
      key: "shipmentLimitDay",
      defaultVal: 2,
      value: 0,
    },
  ],
  temuOriginList: [],
  translateLang: [
    {
      value: "en",
      label: t("英语"),
    },
    {
      value: "zh",
      label: t("中文"),
    },
    {
      value: "ru",
      label: t("俄语"),
    },
    {
      value: "es",
      label: t("西班牙语"),
    },
    {
      value: "vi",
      label: t("越南语"),
    },
    {
      value: "ms",
      label: t("马来语"),
    },
    {
      value: "th",
      label: t("泰语"),
    },
    {
      value: "id",
      label: t("印尼语"),
    },
    {
      value: "pt",
      label: t("葡萄牙语"),
    },
    {
      value: "pl",
      label: t("波兰语"),
    },
    {
      value: "ja",
      label: t("日语"),
    },
    {
      value: "ko",
      label: t("韩语"),
    },
    {
      value: "fr",
      label: t("法语"),
    },
  ],
  remarkColorlist: [
    {
      text: t("无标记"),
      value: "",
    },
    {
      text: t("红色"),
      value: "rgb(255 0 0)",
    },
    {
      text: t("橙色"),
      value: "rgb(255 100 0)",
    },
    {
      text: t("黄色"),
      value: "rgb(241 192 3)",
    },
    {
      text: t("绿色"),
      value: "rgb(0 255 0)",
    },
    {
      text: t("青色"),
      value: "rgb(0 255 255)",
    },
    {
      text: t("蓝色"),
      value: "rgb(0 0 255)",
    },
    {
      text: t("紫色"),
      value: "rgb(255 0 255)",
    },
    {
      text: t("粉色"),
      value: "rgb(255, 192, 203)",
    },
    {
      text: t("金黄"),
      value: "rgb(255, 215, 0)",
    },
    {
      text: t("草绿"),
      value: "rgb(173, 255, 47)",
    },
  ],
  statusList: [
    { text: "已加入站点", value: 12 },
    { text: "待下首单", value: 10 },
    { text: "已下首单", value: 11 },
    { text: "已下架", value: 13 },
    { text: "价格申报中", value: 7 },
    { text: "核价未通过", value: 9 },
    { text: "待上传生产资料", value: 2 },
    { text: "待平台审版", value: 5 },
    { text: "审版不合格", value: 6 },
    { text: "待平台选品", value: 1 },
    { text: "待卖家修改", value: 14 },
    { text: "已修改", value: 15 },
    { text: "待上传生产资料", value: 8 },
    { text: "服饰可加色", value: 16 },
    { text: "待寄样", value: 3 },
    { text: "寄样中", value: 4 },
    { text: "已弃用", value: 0 },
    { text: "已下架", value: 13 },
    { text: "已终止", value: 17 },
  ], //生命周期
  netContentList: [
    {
      label: "液体盎司",
      value: 1,
      unit: "fl.oz",
    },
    {
      label: "毫升",
      value: 2,
      unit: "ml",
    },
    {
      label: "加仑",
      value: 3,
      unit: "gal",
    },
    {
      label: "升",
      value: 4,
      unit: "L",
    },
    {
      label: "克",
      value: 5,
      unit: "g",
    },
    {
      label: "千克",
      value: 6,
      unit: "kg",
    },
    {
      label: "常衡盎司",
      value: 7,
      unit: "oz.av",
    },
    {
      label: "磅",
      value: 8,
      unit: "lb",
    },
    {
      label: "平方英尺",
      value: 9,
      unit: "sq.ft",
    },
    {
      label: "平方米",
      value: 10,
      unit: "sq.m",
    },
    {
      label: "米",
      value: 11,
      unit: "m",
    },
    {
      label: "厘米",
      value: 12,
      unit: "cm",
    },
    {
      label: "英尺",
      value: 13,
      unit: "ft",
    },
    {
      label: "英尺",
      value: 14,
      unit: "ft",
    },
    {
      label: "英寸",
      value: 15,
      unit: "in",
    },
    {
      label: "立方米",
      value: 16,
      unit: "m³",
    },
    {
      label: "毫米",
      value: 17,
      unit: "mm",
    },
    {
      label: "平方毫米",
      value: 18,
      unit: "sq.mm",
    },
    {
      label: "平方厘米",
      value: 19,
      unit: "sq.cm",
    },
    {
      label: "平方英寸",
      value: 20,
      unit: "sq.in",
    },
  ],
  // 同步任务
  taskIdMap: {
    fullyGoodsId: "",
    goodsId: "",
    ordersId: "",
  },
  // 历史采购设置
  purchaserHistory: {
    aliId: "",
    addressId: "",
    remark: "",
  },
  offerIdentitiesMap: {
    "tp_member": "诚信通",
    "powerful_merchants": "实力商家",
    "tp_member": "诚信通",
  }
};

const mutations = {
  setPublishSite(state, data) {
    state.temuPublishSite = data;
    for (let item of Object.values(data.publishSiteOptions)) {
      item.forEach((v) => {
        state.publishSiteIdMap[v.siteId] = {
          ...v,
          ...data[v.area],
        };
      });
    }
    localStorage.setItem(`temu-publish-site`, JSON.stringify(data));
  },
  setOriginList(state, data) {
    state.temuOriginList = data;
    localStorage.setItem(`temu-origin-list`, JSON.stringify(data));
  },
  setTaskId(state, data) {
    for (let key in data) {
      state.taskIdMap[key] = data[key];
    }
    sessionStorage.setItem(`dfx-taskId`, JSON.stringify(state.taskIdMap));
  },
  // 缓存采购员的值
  setPurchaserValue(state, data) {
    for (let key in data) {
      state.purchaserHistory[key] = data[key];
    }
    localStorage.setItem(
      `dfx-purchaser-val`,
      JSON.stringify(state.purchaserHistory),
    );
  },
};

const getters = {};

const actions = {
  getTemuPublishSite({ commit }, { showMsg = true }) {
    return new Promise(async (resolve, reject) => {
      let publishSite = localStorage.getItem(`temu-publish-site`);
      if (publishSite) {
        publishSite = JSON.parse(publishSite);
      } else {
        await ajax.get("/product/temu/getPublishSite").then((res) => {
          if (res.code !== 200) {
            showMsg && Message.error(res.msg);
            return reject(res);
          }
          publishSite = res.result;
        });
      }
      commit("setPublishSite", publishSite);
      resolve(publishSite);
    });
  },
  getTemuOrigin({ commit }) {
    return new Promise(async (resolve) => {
      let originList = localStorage.getItem(`temu-origin-list`);
      if (originList) {
        originList = JSON.parse(originList);
      } else {
        await ajax.get("/product/temu/getProductOrigin").then((res) => {
          if (res.code !== 200) {
            return Message.error(res.msg);
          }
          originList = res.result;
        });
      }
      commit("setOriginList", originList);
      resolve(originList);
    });
  },
  getTaskId({ commit }, { showMsg = true }) {
    return new Promise(async (resolve, reject) => {
      let taskIdData = null;
      await ajax.post("/sync/autoSync").then((res) => {
        if (res.code !== 200) {
          showMsg && Message.error(res.msg);
          return reject(res.msg);
        }
        let { productTaskId, orderTaskId, productFullyTaskId } = res.result;
        taskIdData = {
          goodsId: !["1", "2"].includes(productTaskId) ? productTaskId : "",
          ordersId: !["1", "2"].includes(orderTaskId) ? orderTaskId : "",
          fullyGoodsId: !["1", "2"].includes(productFullyTaskId)
            ? productFullyTaskId
            : "",
        };
      });
      if (!taskIdData) {
        return
      }
      if (!taskIdData.goodsId || !taskIdData.ordersId) {
        let taskIdData2 = sessionStorage.getItem(`dfx-taskId`);
        if (taskIdData2) {
          taskIdData = JSON.parse(taskIdData2);
        }
      }
      commit("setTaskId", taskIdData);
      resolve(taskIdData);
    });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
